var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.623,
    height: 23.611,
    viewBox: "0 0 23.623 23.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.622,250.717H83.648c0-.084-.011-.168-.011-.252v-7.952c0-.215.006-.431,0-.646a.969.969,0,0,0-1-.982q-2.443-.008-4.887,0a.944.944,0,0,0-.946.667,1.669,1.669,0,0,0-.056.477q0,4.218,0,8.436c0,.084-.007.168-.011.253H74.512a1.277,1.277,0,0,1-.734-1.383c.017-3.436.008-6.871.008-10.307v-.24a10.271,10.271,0,0,0,1.034.119c.953.016,1.91,0,2.86.006a2.93,2.93,0,0,0,1.536-.41c.169-.1.326-.221.493-.334a3.191,3.191,0,0,0,2.218.748c1.837-.015,3.674,0,5.511-.006a4.505,4.505,0,0,0,.483-.026,2.956,2.956,0,0,0,1.617-.726,3.15,3.15,0,0,0,2.354.753,20.048,20.048,0,0,0,3.549-.144v10.7C95.441,250.215,95.285,250.453,94.622,250.717Zm-5.59-4.923h2.375a.991.991,0,0,0,1.082-1.092V241.96a.985.985,0,0,0-1.074-1.076H86.664a.985.985,0,0,0-1.069,1.079q0,1.372,0,2.744a.99.99,0,0,0,1.085,1.087Q87.855,245.8,89.032,245.794Z",
    transform: "translate(-72.806 -227.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,186.561c.062,0,.123-.011.185-.011H81.606a2.866,2.866,0,0,1-.551,2.354,1.99,1.99,0,0,1-1.451.6c-.952,0-1.905.008-2.858,0a1.961,1.961,0,0,1-1.968-1.551c-.007-.028-.02-.055-.044-.119-.028.071-.049.113-.062.156a1.941,1.941,0,0,1-1.93,1.511q-2.939.019-5.879,0a1.938,1.938,0,0,1-1.916-1.5c-.014-.049-.031-.1-.058-.18-.027.072-.046.111-.057.153a1.877,1.877,0,0,1-1.782,1.507c-1.074.046-2.152.044-3.226,0a1.889,1.889,0,0,1-1.761-1.446A.974.974,0,0,0,58,187.9Z",
    transform: "translate(-58 -178.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,65.7l1.372-6.862h4.686q.685,3.419,1.373,6.862Z",
    transform: "translate(-181.268 -58.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.654,65.6,320.28,58.73h4.365a1.006,1.006,0,0,1,1.121.84q.835,2.916,1.668,5.83c.017.058.029.118.048.195Z",
    transform: "translate(-304.123 -58.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.837,65.6H62c.137-.485.268-.955.4-1.425q.663-2.319,1.329-4.638a1,1,0,0,1,1.074-.81h4.4C68.751,61.029,68.3,63.311,67.837,65.6Z",
    transform: "translate(-61.754 -58.685)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarter);
export default __webpack_public_path__ + "static/media/starter.d5f495901b6ecdaa0ede794ae9b16921.svg";
export { ForwardRef as ReactComponent };